import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { GetNumbersAggregatorQuery } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { NumbersAggregatorListComponent } from "../numbers-aggregator-list/numbers-aggregator-list.component";


@Component({
    selector: 'app-numbers-aggregator-form',
    templateUrl: './numbers-aggregator-form.component.html',
    imports: [BaseFormModule, NumbersAggregatorListComponent],
    styles: [
        `
      fieldset {
        border: none !important;
      }
    `,
    ]
})
export class NumbersAggregatorFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  model: GetNumbersAggregatorQuery = {};
  mobileNumbers: string;
  isShowNumbersAggregatorList: boolean = false;
  isVisibleHelpPage;

  ngOnInit() {
    try {
      this.getVocabs();
      this.initForm();
      this.pageConfig.showBackBtn = false;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  initForm() {
    this.form = new FormGroup({
      numbers: new FormGroup({
        mobileNumbers: new FormControl('', Validators.required),
      }),
    });
  }

  onSubmit(): void {
    if (!this.isValidForm(this.form, this.tagName)) return;
    if (this.loading) return;

    this.model.numbers = this.mobileNumbers;
  }

  onInquiryMobileAggregators() {
    try {
      this.onSubmit();
      this.isShowNumbersAggregatorList = true;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }
  onShowHelpPage() {
    this.isVisibleHelpPage = true;
  }

  onHideHelpPage() {
    this.isVisibleHelpPage = false;
  }
}
